import { VerbalColorType } from 'foundations-library/types'
import { getValue } from 'remote-config-value'
import { App } from 'apps-marketplace/src/utils/objects'

/**
 *
 */
export const makeFirstLetterUppercase = (text: string) => text.charAt(0).toUpperCase() + text.slice(1)

/**
 *
 */
export const getFirstLetters = (text: string) => text.split(' ').map(word => word.charAt(0)).join('')

/**
 *
 */
export const makeURL = (endpoint: string): RegExp => new RegExp(`^https?://.*/${endpoint}$`, 'i')

/**
 *
 */
export const getStatus = (sim: Record<string, any>, assignedToMe = false) => {
    let statusText = sim?.status || ''
    let statusCaption = ''
    let statusTextColor: VerbalColorType = 'neutral-900'

    let esimStatus = getValue('esim_status') || {}
    if (typeof esimStatus === 'string') {
        esimStatus = JSON.parse(esimStatus)
    }

    const status = sim?.status.toLowerCase()

    const setReadyOrAvailable = (sim) => {
        if (!sim.user) {
            const { text, caption, color } = esimStatus.unAssigned || {}
            statusText = text
            statusCaption = caption
            statusTextColor = color
        } else {
            const { text, caption, captionForMe } = esimStatus.userAssigned || {}
            statusText = text
            statusCaption = !assignedToMe ? caption : captionForMe
        }
    }

    switch (status) {
            case 'ordered':
            case 'backordered': {
                const { text, caption, color } = esimStatus.backordered || {}
                statusText = text
                statusCaption = caption
                statusTextColor = color
                break
            }
            case 'deleted': {
                const { text, color } = esimStatus.deleted || {}
                statusText = text
                statusTextColor = color
                break
            }
            case 'provisioned':
            case 'available': {
                setReadyOrAvailable(sim)
                break
            }
            case 'activated': {
                const { text, caption } = esimStatus.activated || {}
                let formattedDate = ''
                if (sim.activated_at) {
                    const dateObj = new Date(sim.activated_at)
                    formattedDate = dateObj.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
                }
                statusText = text
                if (formattedDate) statusCaption = caption.replace('{DATE}', formattedDate)
                break
            }
    }

    if (sim?.deletion_requested) {
        const { text, caption, color } = esimStatus.deletionRequested || {}
        const terminateDate = new Date(sim.deletion_requested_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
        statusText = text
        statusCaption = caption.replace('{DATE}', terminateDate)
        statusTextColor = color
    }

    return [statusText, statusCaption, statusTextColor]
}

/**
 *
 */
export const makePromise = <T>(arg: T) => new Promise(resolve => resolve(arg))

/**
 *
 */
export const routeToAddEsim = (getPathToNavItem: (navItemId: string) => string | null, esimApp: App|null, history: Record<string, any>) => {
    if (!esimApp || !esimApp.title) return

    const marketplacePath = getPathToNavItem(getValue('nav_apps_marketplace_id'))
    if (!marketplacePath) return

    const esimAppURI = encodeURI(esimApp.title.toLowerCase())
    const esimStepperLink = `${marketplacePath}?app=${esimAppURI}&redirectTo=stepper`
    history.push(esimStepperLink)
}
